/* @jsxImportSource @emotion/react */

import React, { useState } from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'
import { motion } from 'motion/react'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'
import { CaretRightIcon } from '@slite/icons'

import { DemoVideoModal } from './DemoVideoModal'
import { Section } from './Section'

export function DemoVideo({
  youtubeVideoId,
  videoBackgroundURL = 'https://cdn.sanity.io/images/dnsgqii5/production/0f5fad006e9954dc031a05b44beac97d84064652-2000x1125.jpg',
  background,
}: {
  youtubeVideoId?: string
  videoBackgroundURL?: string
  background?: string
}) {
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  return (
    <>
      <DemoVideoModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        youtubeVideoId={youtubeVideoId}
      />
      <Section
        containerTopPadding={30}
        containerBottomPadding={60}
        background={background}
        className="position-relative"
      >
        <div
          css={css`
            position: relative;
            border-radius: 20px;
            margin: 0 auto;

            &:before {
              content: '';
              position: absolute;
              width: calc(100% + 16px);
              height: calc(100% + 10px);
              border: 1.5px solid var(--shade-00);
              border-radius: 24px;
              top: -8px;
              left: -8px;
            }
          `}
          onClick={() => {
            setIsOpen(true)
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="width-full height-full position-relative">
            <div
              className="position-coverer flexbox flexbox-centered pointer"
              style={{ zIndex: 2 }}
              onClick={() => {
                setIsOpen(true)
              }}
            >
              <motion.div
                className={classNames(
                  'flexbox flexbox-align-center flexbox-gap-12',
                  'background-shade-100 padding-left-16 padding-vertical-12 padding-right-20',
                  'shadow-small shadow-medium-on-hover'
                )}
                animate={{
                  scale: isHovered ? 1.1 : 1,
                }}
                transition={{
                  type: 'spring',
                  stiffness: 500,
                  damping: 35,
                  duration: 0.1,
                }}
                style={{
                  borderRadius: 60,
                }}
              >
                <div
                  className="background-primary flexbox flexbox-centered"
                  style={{ width: 32, height: 32, borderRadius: 24 }}
                >
                  <CaretRightIcon className="white" size={20} />
                </div>
                <div className="font-size-6 shade-05 font-family-title font-weight-medium">
                  <FormattedMessage
                    id="slite.suite.videodemo.cta"
                    defaultMessage="Play video"
                  />
                </div>
              </motion.div>
            </div>

            <ImgSanity
              src={videoBackgroundURL}
              alt={intl.formatMessage({
                id: 'super.videodemo.alt',
                defaultMessage: 'thumbnail of super demo',
              })}
              className="radius-semilarger pointer"
            />
          </div>
        </div>
      </Section>
    </>
  )
}
